
import React from "react";
import { TabsList, TabsTrigger } from "@/components/ui/tabs";
import { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

export interface TabItem {
  value: string;
  label: string;
  icon: LucideIcon;
  count?: number;
  badge?: {
    count: number;
    variant?: "default" | "primary" | "secondary" | "destructive";
  };
}

interface TabNavigationProps {
  tabs: TabItem[];
  className?: string;
  value?: string;
  onValueChange?: (value: string) => void;
}

const TabNavigation: React.FC<TabNavigationProps> = ({ 
  tabs,
  className,
  value,
  onValueChange
}) => {
  return (
    <TabsList className={cn("mb-6 relative", className)}>
      {tabs.map((tab) => (
        <TabsTrigger 
          key={tab.value} 
          value={tab.value} 
          className="flex items-center gap-1 transition-all duration-300 ease-in-out group"
          onClick={() => onValueChange && onValueChange(tab.value)}
          data-state={value === tab.value ? "active" : "inactive"}
        >
          <tab.icon className="h-4 w-4 transition-transform group-hover:scale-110 duration-200" />
          <span className="transition-opacity duration-300">{tab.label}</span>
          {tab.count !== undefined && (
            <span className="ml-1 text-xs text-muted-foreground">({tab.count})</span>
          )}
          {tab.badge && tab.badge.count > 0 && (
            <span className={cn(
              "ml-1 text-xs rounded-full px-1.5 py-0.5 transition-all duration-300", 
              tab.badge.variant === "primary" ? "bg-primary text-primary-foreground" : 
              "bg-secondary text-secondary-foreground"
            )}>
              {tab.badge.count}
            </span>
          )}
        </TabsTrigger>
      ))}
    </TabsList>
  );
};

export default TabNavigation;
